import React, { FC, useEffect, useState } from 'react';
import { Box, Button, IconButton } from '@chakra-ui/react';
import { FaTrash } from 'react-icons/fa6';
import { MdAdd } from 'react-icons/md';

import Dialog from '@app/components/common/modals/dialog';
import TextField from '@app/components/common/text-field';
import api from '@app/api/api';
import { useAlert } from '@app/hooks/use-alert';
import { MailingItem } from '@app/api/models/admin';
import { Txt } from '@app/components/common';

interface EditMailingProps {
  open: boolean;
  setOpen(value: boolean): void;
  mailingList?: MailingItem;
}

export const EditMailing: FC<EditMailingProps> = ({ open, setOpen, mailingList }) => {
  const [value, setValue] = useState<string[]>(mailingList?.value || []);
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const { success } = useAlert();

  const onSubmit = async () => {
    setLoading(true);
    await api.admin.updateMailingList({ id: mailingList.id, value });
    setLoading(false);
    success('Сохранено');
    setOpen(false);
  };

  useEffect(() => {
    setValue(mailingList?.value || []);
  }, [mailingList]);

  const onAddEmail = () => {
    if (!email.trim().length) {
      setError('Пусто');
      return;
    }
    if(value.findIndex((item) => item === email.trim()) !== -1) {
      setError('Таки этот Email уже как-бы есть');
      return;
    }
    if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      setError('Невалидно');
      return;
    }

    setValue([email, ...value]);
    success('Добавлено');
  };

  const onRemoveEmail = (index: number) => () => {
    setValue([...value.slice(0, index), ...value.slice(index + 1)]);
    success('Удалено');
  };

  return (
    <Dialog
      title="Изменить Email-рассылку"
      open={open}
      onClose={() => setOpen(false)}
      loading={loading}
      width='md'
      actions={
        <>
          <Button variant='contained' color='primary' onClick={onSubmit}>
            Изменить
          </Button>
        </>
      }
    >
      <Box mb={2} display="flex" 
        flexDirection="row"
        style={{ gap: '8px' }}
      >
        <Txt color='textSecondary'>Ключ:</Txt>
        <Txt>{mailingList?.key}</Txt>
      </Box>
      <Box mb={2} display="flex" 
        flexDirection="row"
        style={{ gap: '8px' }}
      >
        <Txt color='textSecondary'>Описание:</Txt>
        <Txt>{mailingList?.description}</Txt>
      </Box>
      <Box mb={1} display="flex" 
        flexDirection="row" justifyContent="space-between" alignItems='flex-start'
        style={{ gap: '16px' }}
      >
        <TextField
          id=""
          label="Email"
          value={email}
          onChange={setEmail}
          error={!!error}
          helperText={error}
        />
        <Box>
          <IconButton colorScheme='brand' onClick={onAddEmail} aria-label="add" >
            <MdAdd />
          </IconButton>
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" maxHeight='70vh' overflow='auto'>
        {value.map((email, index) => <Box key={email} display="flex" 
          flexDirection="row" justifyContent="space-between" alignItems='center' mb={1}
          pl={2}
        >
          <Box fontSize={16}>{email}</Box>
          <IconButton onClick={onRemoveEmail(index)} aria-label="remove">
            <FaTrash />
          </IconButton>
        </Box>)}
      </Box>
    </Dialog>
  );
};

export default EditMailing;
